module.exports = __webpack_public_path__ + "archivist_badge_03.jpg?e16ac283bd8f812053347c826b4e9919";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge/archivist_badge_03.jpg
// module id = 378
// module chunks = 0